import React from 'react';

const Page10AwarenessERFeedbackAndReasons = ({ 
  erRating,
  setErRating,
  ratingReason,
  setRatingReason,
  handlePrevious,
  handleNext 
}) => {
  return (
    <>
      <div className="questions-grid">
        <div className="question-item full-width">
          <label>On a scale of 0-10, how satisfied are you with the responsiveness of Cloudphysician's ER team?</label>
          <div className="nps-scores">
            {[...Array(11)].map((_, index) => (
              <button
                key={index}
                className={`score-button ${erRating === index ? 'selected' : ''}`}
                onClick={() => setErRating(index)}
              >
                {index}
              </button>
            ))}
          </div>
          <p className="rating-description">
            0 = Not at all satisfied, 10 = Extremely satisfied
          </p>
        </div>

        <div className="question-item full-width">
          <label>Please explain your reasons for this rating.</label>
          <textarea
            value={ratingReason}
            onChange={(e) => setRatingReason(e.target.value)}
            placeholder="Please provide your detailed feedback here..."
            className="long-answer-input"
          />
        </div>
      </div>
      <div className="button-group">
        <button className="nav-button" onClick={handlePrevious}>Previous</button>
        <button 
          className="nav-button" 
          onClick={handleNext}
          disabled={erRating === null || !ratingReason.trim()}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default Page10AwarenessERFeedbackAndReasons; 